export default __webpack_public_path__ + "static/media/login.def11215.png";